import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers the service worker that makes the app installable (see
// public/sw.js). Production only — in dev it would sit in front of Vite's
// module graph and serve stale code through hot reloads.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      // Installability is an enhancement; the app works without it, so a
      // failure here is logged rather than surfaced to the student.
      console.warn('[PWA] Service worker registration failed', error);
    });
  });
}
